module.exports = __webpack_public_path__ + "static/media/S3N10-5.44267f28.svg";